const SupplierDetailBreadcrumbConstant = [
  { title: "Suppliers", link: "/user/suppliers" },
  { title: "Supplier Detail", link: "", is_active: true },
];

export default SupplierDetailBreadcrumbConstant;
